import { FC, useEffect, useState } from 'react';
import { IEntityContentField } from '../../../lib/interfaces/Common';

type CodeSandboxEmbedProps = {
	field: IEntityContentField;
};

const CodeSandboxEmbed: FC<CodeSandboxEmbedProps> = ({ field }) => {
	const sandboxId = field.content;
	const [show, setShow] = useState(false);
	useEffect(() => {
		if (!show) {
			setTimeout(() => {
				setShow(true);
			}, 100);
		}
	}, [show]);
	return show ? (
		<iframe
			src={`https://codesandbox.io/embed/${sandboxId}?fontsize=14&hidenavigation=1&theme=dark`}
			style={{
				width: '100%',
				height: '500px',
				border: 0,
				borderRadius: '4px',
			}}
			title="magical-chihiro-5gx6wd"
			allow=""
			sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
		/>
	) : (
		<div>Loading...</div>
	);
};

export default CodeSandboxEmbed;
